import { render, staticRenderFns } from "./OnlineServicePensionCalculator.vue?vue&type=template&id=2a266166"
import script from "./OnlineServicePensionCalculator.vue?vue&type=script&lang=js"
export * from "./OnlineServicePensionCalculator.vue?vue&type=script&lang=js"
import style0 from "./OnlineServicePensionCalculator.vue?vue&type=style&index=0&id=2a266166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports